module.exports = __webpack_public_path__ + "img/gps.859a9e7e.jpg";